package com.dignicate.web.data.markdown.parser.handlers

import com.dignicate.web.data.markdown.model.MarkdownBlock
import com.dignicate.web.data.markdown.parser.core.MarkdownHandler
import com.dignicate.web.data.markdown.parser.core.ParsingContext

class ParagraphHandler : MarkdownHandler {
    override fun canHandle(ctx: ParsingContext): Boolean {
        return ctx.currentLine()?.isNotBlank() == true
    }

    override fun handle(ctx: ParsingContext) {
        val paragraphLines = mutableListOf<String>()
        while (!ctx.isEof() && ctx.currentLine()?.isNotBlank() == true) {
            paragraphLines.add(ctx.currentLine()!!)
            ctx.index++
        }
        ctx.blocks.add(MarkdownBlock.Paragraph(paragraphLines.joinToString(" ")))
    }
}
